const amenitiesEn = {
    resource: require('lang/en/amenities/Resource').default,
    booking: require('lang/en/amenities/Booking').default,
}

export default amenitiesEn;